// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3FVZE","header":"ReportDetails_header__15kG2","title":"ReportDetails_title__3_Inp","left":"ReportDetails_left__3a06X"};